export default __webpack_public_path__ + "images/block-client.ff71dc87.svg";